import { Button } from '@givebutter/primitives/button';
import * as Dialog from '@radix-ui/react-dialog';

const TaskFooter = () => {
    return (
        <div className="flex justify-end border-t border-gray-200 bg-gray-50 px-6 py-4">
            <Dialog.Trigger asChild>
                <Button variant="outline" color="neutral">
                    Close
                </Button>
            </Dialog.Trigger>
        </div>
    );
};

export { TaskFooter };
